import { ICountListGroupPropertyBehavior } from "../../../interfaces/form-builder/i-behavior";
import { NoteDataManager } from "../note-data-manager";

export class ListGroupPropertyCountHandler {
    public handle(countListGroupPropertyBehavior: ICountListGroupPropertyBehavior, noteDataManager: NoteDataManager) {
        let listGroupLength = noteDataManager.getListCount(countListGroupPropertyBehavior.listGroupName);
        if (!listGroupLength) {
            return 0;
        }
        let propertyCount = 0;
        let noteModel = noteDataManager.getNoteModel();
        let propertyList = [];
        while (propertyCount < listGroupLength) {
            let propertyName = `${countListGroupPropertyBehavior.listGroupName}.${propertyCount}.${countListGroupPropertyBehavior.targetName}`;
            let minProperty = `${countListGroupPropertyBehavior.listGroupName}.${propertyCount}.${countListGroupPropertyBehavior.minPropertyName}`;
            let maxProperty = `${countListGroupPropertyBehavior.listGroupName}.${propertyCount}.${countListGroupPropertyBehavior.maxPropertyName}`;
            if (!!noteModel[minProperty] && !!noteModel[maxProperty]) {
                propertyList.push({ name: propertyName, value: noteModel[propertyName] });
            }
            propertyCount++;
        }
        let filterList = propertyList.filter((property) => {
            if (Array.isArray(property.value)) {
                return property.value.join("") === countListGroupPropertyBehavior.values.join("");
            } else {
                return countListGroupPropertyBehavior.values.length > 0
                    ? countListGroupPropertyBehavior.values.includes(property.value as any)
                    : !property.value;
            }
        });
        return filterList.length;
    }
}
